import React from 'react';
import PropTypes from 'prop-types';

/**
 * Links that represent the given data for each subjects card. These are coupled with icons using the titleToIcons obj
 */
const IconLinks = (props) => {
	const { products, title } = props;

	// Essay Lab (and any other un-entitled items) are now filtered out by the GetSubjects API,
	// so we render icon_products as-is.
	let links = { ...products };

	let titleToIcons = {
		'Courses': 'https://media1.shmoop.com/images/sitewide/teachericon-shmoop.svg',
		'Test Prep Home': 'https://media1.shmoop.com/images/sitewide/studyguidesicon-shmoop.svg',
		'Study Guides': 'https://media1.shmoop.com/images/sitewide/studyguidesicon-shmoop.svg',
		'Videos': 'https://media1.shmoop.com/images/sitewide/videoicon-shmoop.svg',
		'Math Shack': 'https://media1.shmoop.com/images/sitewide/studyguideicon-shmoop.svg'
	};

	return (
		<div className={'icon-links'}>
			{Object.keys(links).map((key, item) =>
				<div key={key}>
					<a href={links[key].url} data-item={item} className={'pl-0'}>
						<img src={titleToIcons[links[key].label]} alt={title + ': ' + links[key].label}/>
					</a>
					<a href={links[key].url} data-item={item}>
						{links[key].label}
					</a>
				</div>
			)}
		</div>
	);
};

export default IconLinks;

IconLinks.propTypes = {
	products: PropTypes.array,
	title: PropTypes.string
};
